<template>
  <div class="page-container">
    <Header />
    <div
      class="top media-wrapper"
      :style="{ height: calculatedTopHeight + 'px' }"
    >
      <img src="@/assets/images/03/RadSys2/01.png" alt="" />
      <div class="info">
        <span class="main-title">{{ $t("radsys2") }}</span>
        <span class="sub-title">{{ $t("radsys2_desc") }}</span>
      </div>
    </div>
    <div class="part-01 part-01-margin">
      <div class="part-container all-wrapper">
        <div class="part-left">
          <img
            src="@/assets/images/03/RadSys2/02.png"
            alt=""
            class="left-big-img mobile-hide"
          />
          <div class="item-row">
            <div class="item white mobile-hide" @click="handleClick('RadWall')">
              <img src="@/assets/images/03/RadSys2/3.png" alt="" />
            </div>
            <div class="item white item-card" @click="handleClick('RadWall')">
              <img
                src="@/assets/images/03/RadSys2/3.png"
                alt=""
                class="card-img desktop-hide"
              />
              <span class="item-name">RadWall</span>
              <span class="item-sub-name">{{ $t("radwall_fixed_short") }}</span>
            </div>
          </div>
        </div>
        <div class="part-right">
          <div class="item-row">
            <div class="item gray item-card" @click="handleClick('radsys')">
              <span class="item-name">RadSys</span>
              <span class="item-sub-name">{{ $t("radsys_short") }}</span>
            </div>
            <div class="item empty-item desktop-only"></div>
          </div>
          <div class="item-row">
            <div
              class="item white mobile-hide"
              @click="handleClick('radtrarge')"
            >
              <img src="@/assets/images/03/RadSys2/1.png" alt="" />
            </div>
            <div class="item red item-card" @click="handleClick('radtrarge')">
              <img
                src="@/assets/images/03/RadSys2/1.png"
                alt=""
                class="card-img desktop-hide"
              />
              <span class="item-name">RadTarge</span>
              <span class="item-sub-name">{{
                $t("radtarge_series_short")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-02">
      <div class="part-container all-wrapper">
        <img
          src="@/assets/images/03/RadSys2/C.png"
          alt=""
          class="left-big-img mobile-hide"
        />
        <div class="item-row">
          <div class="item white mobile-hide" @click="handleClick('RadPavise')">
            <img src="@/assets/images/03/RadSys2/RadPavise.png" alt="" />
          </div>
          <div class="item red item-card" @click="handleClick('RadPavise')">
            <img
              src="@/assets/images/03/RadSys2/RadPavise.png"
              alt=""
              class="card-img desktop-hide"
            />
            <span class="item-name">RadPavise</span>
            <span class="item-sub-name">{{ $t("radpavise_short") }}</span>
          </div>
          <div
            class="item white mobile-hide"
            @click="handleClick('RadWall-Mu')"
          >
            <img src="@/assets/images/03/RadSys2/RadWall.png" alt="" />
          </div>
          <div class="item white item-card" @click="handleClick('RadWall-Mu')">
            <img
              src="@/assets/images/03/RadSys2/RadWall.png"
              alt=""
              class="card-img desktop-hide"
            />
            <span class="item-name">RadWall-Mu</span>
            <span class="item-sub-name">{{ $t("radwall_mu_short") }}</span>
          </div>
          <div class="item empty-item desktop-only"></div>
        </div>
        <div class="item-row">
          <div class="item white mobile-hide" @click="handleClick('RadHFC')">
            <img src="@/assets/images/03/RadSys2/1111.png" alt="" />
          </div>
          <div class="item white item-card" @click="handleClick('RadHFC')">
            <img
              src="@/assets/images/03/RadSys2/1111.png"
              alt=""
              class="card-img desktop-hide"
            />
            <span class="item-name">RadHFC</span>
            <span class="item-sub-name">{{ $t("product_radhfc") }}</span>
          </div>
          <div
            class="item white mobile-hide"
            @click="handleClick('RadTarge-Mini')"
          >
            <img src="@/assets/images/03/RadSys2/4.png" alt="" />
          </div>
          <div class="item red item-card" @click="handleClick('RadTarge-Mini')">
            <img
              src="@/assets/images/03/RadSys2/4.png"
              alt=""
              class="card-img desktop-hide"
            />
            <span class="item-name">RadTarge-Mini</span>
            <span class="item-sub-name">{{ $t("radtarge_mini_short") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="part-03">
      <div class="part-container right-wrapper">
        <div class="tag tag-03">{{ $t("solutions") }}</div>
        <div class="item-row">
          <div class="item red item-solution" style="overflow: visible">
            <div>
              <span class="item-name">{{ $t("solution_ect_short") }}</span>
              <span class="item-name">{{ $t("solution_monitoring") }}</span>
            </div>
            <img src="@/assets/images/03/RadSys2/s-01.png" alt="" />
          </div>
          <div class="item gray item-solution">
            <div>
              <span class="item-name">{{
                $t("solution_accelerator_short")
              }}</span>
              <span class="item-name">{{ $t("solution_petct_short") }}</span>
            </div>
            <img src="@/assets/images/03/RadSys2/s-02.png" alt="" />
          </div>
          <div class="item red item-solution">
            <div>
              <span class="item-name">{{ $t("solution_ward_short") }}</span>
              <span class="item-name">{{ $t("solution_monitoring") }}</span>
            </div>
            <img src="@/assets/images/03/RadSys2/s-03.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="part-04">
      <div class="carousel-full-wrapper">
        <div class="carousel-header">
          <div class="tag">{{ $t("application_cases") }}</div>
        </div>
        <div class="carousel-container">
          <button
            class="carousel-btn prev"
            @click="prevImage"
            :disabled="currentIndex === 0"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="20"
                cy="20"
                r="20"
                fill="#85061B"
                fill-opacity="0.8"
              />
              <path
                d="M25 20L15 20M15 20L20 15M15 20L20 25"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <div class="carousel-track">
            <div
              class="carousel-images"
              :style="{
                transform: `translateX(-${
                  currentIndex * (imageWidth + gapWidth)
                }px)`,
              }"
            >
              <div
                class="carousel-item"
                v-for="(img, index) in carouselImages"
                :key="index"
              >
                <img :src="img" alt="" />
              </div>
            </div>
          </div>
          <button
            class="carousel-btn next"
            @click="nextImage"
            :disabled="currentIndex >= maxIndex"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="20"
                cy="20"
                r="20"
                fill="#85061B"
                fill-opacity="0.8"
              />
              <path
                d="M15 20L25 20M25 20L20 15M25 20L20 25"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="part-05">
      <div class="part-container left-wrapper">
        <div class="item-row">
          <div class="left-img">
            <div class="tag">
              <span>{{ $t("customer_list") }}</span>
            </div>
            <img
              src="@/assets/images/03/RadSys2/R.png"
              alt=""
              class="opacity-img mobile-hide"
            />
          </div>
          <div class="right-img">
            <img src="@/assets/images/03/RadSys2/666-26.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import al01 from "@/assets/images/03/RadSys2/al-01.png";
import al02 from "@/assets/images/03/RadSys2/al-02.png";
import al03 from "@/assets/images/03/RadSys2/al-03.png";
import al04 from "@/assets/images/03/RadSys2/al-04.png";
import al05 from "@/assets/images/03/RadSys2/al-05.png";
import al06 from "@/assets/images/03/RadSys2/al-06.jpg";
import al07 from "@/assets/images/03/RadSys2/al-07.jpg";
import al08 from "@/assets/images/03/RadSys2/al-08.jpg";
import al09 from "@/assets/images/03/RadSys2/al-09.jpg";
import al10 from "@/assets/images/03/RadSys2/al-10.jpg";
import al11 from "@/assets/images/03/RadSys2/al-11.jpg";

export default {
  name: "",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      calculatedTopHeight: 0,
      currentIndex: 0,
      imageWidth: 200,
      gapWidth: 20,
      visibleCount: 5,
      isMobile: false,
      touchStartX: 0,
      touchCurrentX: 0,
    };
  },
  computed: {
    carouselImages() {
      return [al01, al02, al03, al04, al05, al06, al07, al08, al09, al10, al11];
    },
    maxIndex() {
      return Math.max(0, this.carouselImages.length - this.visibleCount);
    },
  },
  mounted() {
    this.calculateBackgroundHeight();
    this.calculateVisibleCount();
    this.checkMobile();
    window.addEventListener("resize", this.handleResize);
    this.$nextTick(() => {
      const track = document.querySelector(".carousel-track");
      if (track) {
        track.addEventListener("touchstart", this.onTouchStart, {
          passive: true,
        });
        track.addEventListener("touchmove", this.onTouchMove, {
          passive: false,
        });
        track.addEventListener("touchend", this.onTouchEnd);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    const track = document.querySelector(".carousel-track");
    if (track) {
      track.removeEventListener("touchstart", this.onTouchStart);
      track.removeEventListener("touchmove", this.onTouchMove);
      track.removeEventListener("touchend", this.onTouchEnd);
    }
  },
  methods: {
    handleClick(val) {
      this.$router.push("/" + val);
    },
    handleResize() {
      this.calculateBackgroundHeight();
      this.calculateVisibleCount();
    },
    calculateBackgroundHeight() {
      this.$nextTick(() => {
        const bgImage = new Image();
        bgImage.src = require("@/assets/images/03/RadSys2/03.png");

        bgImage.onload = () => {
          const container = document.querySelector(".page-container");
          const containerWidth = container.offsetWidth;

          const aspectRatio = bgImage.height / bgImage.width;
          const scaledBgHeight = containerWidth * aspectRatio;

          let height = scaledBgHeight - 72;
          if (window.innerWidth <= 768) {
            height = Math.max(250, Math.min(400, height));
          }
          this.calculatedTopHeight = height;
        };
      });
    },
    calculateVisibleCount() {
      this.$nextTick(() => {
        const track = document.querySelector(".carousel-track");
        if (track) {
          const trackWidth = track.offsetWidth;
          this.visibleCount = Math.max(
            1,
            Math.floor(
              (trackWidth + this.gapWidth) / (this.imageWidth + this.gapWidth)
            )
          );
        }
      });
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    nextImage() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchCurrentX = this.touchStartX;
    },
    onTouchMove(e) {
      this.touchCurrentX = e.touches[0].clientX;
      if (this.isMobile) {
        e.preventDefault();
      }
    },
    onTouchEnd() {
      const diff = this.touchStartX - this.touchCurrentX;
      if (Math.abs(diff) < 30) return;
      if (diff > 0) {
        this.nextImage();
      } else {
        this.prevImage();
      }
    },
  },
};
</script>

<style lang='less' scoped>
@import "@/assets/styles/views/common.less";

.page-container {
  background: url(@/assets/images/03/RadSys2/03.png);
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
}

.top {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 0;

  .info {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 40px;
    color: #fff;

    span {
      transition: transform 0.3s ease, color 0.3s ease;
      cursor: pointer;
      display: inline-block;
    }

    span:hover {
      transform: scale(1.05);
      color: white;
    }
  }

  img {
    width: 720px;
    height: auto;
    transition: transform 0.3s ease;
  }

  img:hover {
    transform: scale(1.05);
  }
}
.item {
  padding: 20px;
  cursor: pointer;
  position: relative;
  text-align: center;
  .pointer {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 40px !important;
    height: 30px !important;
  }
}

/* Desktop-only helper classes */
.desktop-only {
  display: block;
}

.desktop-hide {
  display: none;
}

.part-01-margin {
  margin-top: 100px;
}

.empty-item {
  background: transparent;
}

.item-img-bg {
  background-color: #fff;
}

.opacity-img {
  opacity: 0.6;
}

.tag-03 {
  position: absolute;
  text-align: center;
  top: -75px;
  left: 0;
  color: #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }
}

.item-solution {
  width: 30%;
  display: flex;
  flex-direction: row;
  height: 500px;
  padding-right: 0;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: left;
    word-break: break-word;
    width: 30%;

    span {
      margin-bottom: 0;
      font-size: 14px!important;
      transition: transform 0.3s ease;
    }

    span:hover {
      transform: scale(1.05);
    }
  }
}

.part-01 {
  margin-top: 50px;
  .part-container {
    height: 700px;
  }
  .left-big-img {
    object-position: bottom right;
  }
  .part-left {
    flex: 1;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
    width: unset;

    & > img {
      right: 0;
      left: revert;
      width: 90%;
      height: 700px;
      object-fit: contain;
      transition: transform 0.3s ease;
    }

    & > img:hover {
      transform: scale(1.05);
    }
  }

  .part-right {
    justify-content: flex-end;
    align-items: flex-end;
    width: unset;

    img {
      width: auto;
      height: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }
  }
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.part-02 {
  margin-top: 0;
  height: 500px;

  .left-big-img {
    width: 600px;
    height: 500px;
    transition: transform 0.3s ease;
  }

  .left-big-img:hover {
    transform: scale(1.05);
  }

  .part-container {
    display: flex;
    flex-direction: column;
  }

  .item-row {
    display: flex;
    justify-content: flex-end;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: auto;
      height: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }
  }
}

.part-03 {
  margin-top: 125px;
  height: 500px;

  .part-container {
    display: flex;
    flex-direction: column;
  }

  .item-row {
    display: flex;
    justify-content: flex-end;
    gap: 30px;

    img {
      width: calc(70% + 20px);
      height: 100%;
      flex: 1;
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }
  }
}

.part-04 {
  height: 350px;
  background-color: rgb(243 243 243);

  .carousel-full-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .carousel-header {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;

    .tag {
      color: #333;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .tag:hover {
      transform: scale(1.1);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    }
  }

  .carousel-container {
    position: relative;
    margin-top: 20px;
  }

  .carousel-track {
    width: calc(100% - 60px);
    margin-left: 60px;
    overflow: hidden;
  }

  .carousel-images {
    display: flex;
    gap: 20px;
    transition: transform 0.3s ease;
  }

  .carousel-item {
    flex-shrink: 0;
    width: 200px;
    height: 200px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .carousel-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border: none;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #333;
    transition: all 0.3s ease;
    z-index: 10;

    &.prev {
      left: 10px;
    }

    &.next {
      right: -50px;
    }

    &:hover:not(:disabled) {
      background-color: #89031c;
      color: #fff;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

@media (width > 1920px) {
  .part-04 {
    .carousel-full-wrapper {
      width: calc(50% + 840px);
    }
    .carousel-header {
      padding-right: 0;
    }
  }
}

@media (width <= 1920px) {
  .part-04 {
    .carousel-full-wrapper {
      width: calc(50% + 700px);
    }
    .carousel-header {
      padding-right: 0;
    }
  }
}

@media (width <= 1400px) {
  .part-04 {
    .carousel-full-wrapper {
      width: calc(50% + 600px);
    }
    .carousel-header {
      padding-right: 0;
    }
  }
}

@media (width <= 1200px) {
  .part-04 {
    .carousel-full-wrapper {
      width: 100%;
    }
    .carousel-container {
      padding: 0 20px;
    }
    .carousel-header {
      padding-right: 20px;
    }
  }
}

.part-05 {
  margin-top: 100px;
  margin-bottom: 50px;

  .part-container {
    display: flex;
    flex-direction: column;
  }

  .left-img {
    position: relative;

    .tag {
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      transition: transform 0.3s ease, box-shadow 0.3s ease;

      &:hover {
        transform: translateX(-50%) scale(1.1);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
      }

      &::before {
        content: "";
        width: 3px;
        height: 250px;
        background-color: #89031c;
        display: block;
        position: absolute;
        top: 0;
        right: -4px;
      }
    }

    img {
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }
  }

  .right-img {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    img {
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }
  }
}

#app[lang="en"] {
  .tag {
    font-size: 16px;
    width: 120px;
  }
  .item-name {
    line-height: 20px;
  }
}

@media (max-width: 768px) {
  .page-container {
    background-size: cover;
    height: 100vh;
  }

  .mobile-hide {
    display: none !important;
  }

  .desktop-hide {
    display: block;
  }

  .desktop-only {
    display: none !important;
  }

  .card-img {
    width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;
  }

  .item-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    height: auto;
    min-height: 80px;
    padding: 15px;

    img {
      width: auto;
      height: auto;
    }

    .item-name {
      text-align: left;
    }

    .item-sub-name {
      text-align: left;
      font-size: 14px;
    }
  }

  .top {
    flex-direction: column;
    gap: 20px;
    padding: 20px 15px;

    img {
      width: 100%;
      height: auto;
      max-width: 300px;
    }

    .info {
      font-size: 24px;
      position: relative;
      top: auto;
    }
  }

  .part-01-margin {
    margin-top: 0;
  }

  .part-01 {
    margin-top: 0;

    .part-container {
      height: auto;
      flex-direction: column;
    }

    .left-big-img {
      position: relative;
      width: 100%;
      height: auto;
      max-height: 200px;
      top: auto;
    }

    .part-left,
    .part-right {
      width: 100%;
      display: contents;
    }

    .item-row {
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  .empty-item {
    display: none;
  }

  .part-02 {
    margin-top: 30px;
    height: auto;

    .left-big-img {
      position: relative;
      width: 100%;
      height: auto;
      max-height: 200px;
    }

    .part-container {
      flex-direction: column;
      padding: 0 15px;
    }

    .item-row {
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  .part-03 {
    margin-top: 50px;
    height: auto;

    .part-container {
      flex-direction: column;
      padding: 0 15px;
    }

    .tag-03 {
      position: relative;
      width: 60px;
      height: 60px;
      font-size: 18px;
      letter-spacing: 3px;
      word-break: break-word;
      top: auto;
      left: 15px;
      margin-bottom: 20px;
    }

    .item-row {
      flex-direction: column;
      gap: 10px;

      .item {
        width: 100%;
        height: auto;
        min-height: 80px;
        flex-direction: column;
        padding: 15px;

        & > div {
          width: 100%;
          text-align: left;

          span {
            font-size: 16px;
          }
        }

        img {
          width: 100%;
          height: auto;
          max-height: 200px;
          object-fit: contain;
        }
      }
    }

    .tag {
      position: relative;
      top: auto;
      left: auto;
    }
  }

  .item-solution {
    width: 100%;
    height: auto;
    flex-direction: column;

    & > div {
      width: 100%;
    }

    img {
      width: 100%;
      height: auto;
      max-height: 200px;
      object-fit: contain;
    }
  }

  .part-04 {
    height: auto;
    padding: 20px 0;

    .carousel-header {
      padding-left: 15px;

      .tag {
        width: 60px;
        height: 60px;
        font-size: 18px;
        letter-spacing: 3px;
        word-break: break-word;
      }
    }

    .carousel-track {
      margin-left: 0;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scroll-snap-type: x mandatory;
    }

    .carousel-images {
      transition: none;
    }

    .carousel-item {
      width: 200px;
      height: 200px;
      scroll-snap-align: start;
    }

    .carousel-btn {
      width: 44px;
      height: 44px;

      &.next {
        right: 10px;
      }
    }
  }

  .part-05 {
    margin-top: 50px;
    margin-bottom: 30px;

    .left-img {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 100%;

      .tag {
        position: relative;
        left: 15px;
        transform: none;
        width: 60px;
        height: 60px;
        font-size: 18px;
        letter-spacing: 3px;
        word-break: break-word;

        &::before {
          display: none;
        }

        &:hover {
          transform: none;
          box-shadow: none;
        }
      }

      img {
        width: 100%;
        height: auto;
        opacity: 1;
      }

      img:hover {
        transform: none;
      }
    }

    .right-img {
      img:hover {
        transform: none;
      }
    }

    .item-row {
      flex-wrap: wrap;
    }
  }
}
</style>